import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { CartStore }  from "./cart.store";
import { BundlableCartItemDto, CartItemDto } from "../api";
import { getCartStore } from "../utils";

export class CartItemComponent extends AlpineComponent {
    private quantityUpdateTimeout: number | null | undefined = null;
    public cartItem: CartItemDto | BundlableCartItemDto;
    public stagingQuantity: number;


    constructor(cartItem: CartItemDto | BundlableCartItemDto) {
        super();
        this.cartItem = cartItem;
        this.stagingQuantity = cartItem.quantity;
    }

    protected IncreaseQuantityButton = this.binding({
        ["x-on:click.prevent"]() {
            this.increaseQuantity();
        },
        ["x-bind:disabled"]() {
            return (this.$store.cart as CartStore).loading;
        }
    });
    protected DecreaseQuantityButton = this.binding({
        ["x-on:click.prevent"]() {
            this.decreaseQuantity();
        },
        ["x-bind:disabled"]() {
            return (this.$store.cart as CartStore).loading;
        }
    });
    protected QuantityInput = this.binding({
        ["x-on:change.debounce.500ms"](event: InputEvent) {
            this.updateQuantityFromInput(event);
        },
        ["x-model"]() {
            return this?.stagingQuantity;
        },
        ["x-bind:disabled"]() {
            return (this.$store.cart as CartStore).loading;
        }
    });
    protected RemoveItemButton = this.binding({
        ["x-on:click.prevent"]() {
            this.removeItem();
        }
    });

    async increaseQuantity() {
        this.stagingQuantity += 1;

        if(this.stagingQuantity == this.cartItem.quantity) {
            return;
        }

        let cartStore = getCartStore();

        if (this.quantityUpdateTimeout) {
            clearTimeout(this.quantityUpdateTimeout);
        }

        this.quantityUpdateTimeout = setTimeout(async () => {
            await cartStore.UpdateProduct(this.cartItem.id, {
                quantity: this.stagingQuantity
            }, false);

            const matchingOrderLine = cartStore.FindOrderLine(this.cartItem.id)
            if(matchingOrderLine) {
                this.cartItem = matchingOrderLine;
                this.stagingQuantity = matchingOrderLine.quantity;
            }
        }, 600, []);
    }

    async decreaseQuantity() {
        this.stagingQuantity = Math.max(1, this.stagingQuantity - 1);

        let cartStore = getCartStore();

        if(this.stagingQuantity == this.cartItem.quantity) {
            return;
        }

        if (this.quantityUpdateTimeout) {
            clearTimeout(this.quantityUpdateTimeout);
        }

        this.quantityUpdateTimeout = setTimeout(async () => {
            await cartStore.UpdateProduct(this.cartItem.id, {
                quantity: this.stagingQuantity
            }, false);

            const matchingOrderLine = cartStore.FindOrderLine(this.cartItem.id)
            if(matchingOrderLine) {
                this.cartItem = matchingOrderLine;
                this.stagingQuantity = matchingOrderLine.quantity;
            }
        }, 600, []);
    }

    async updateQuantityFromInput(event : InputEvent) {
        const inputElement = event.target as HTMLInputElement;
        const newQuantity = parseInt(inputElement.value);
        if(isNaN(newQuantity)) {
            console.error("Invalid quantity");
            return;
        }

        if(newQuantity == this.cartItem.quantity) {
            return;
        }

        let cartStore = getCartStore();

        if (this.quantityUpdateTimeout) {
            clearTimeout(this.quantityUpdateTimeout);
        }

        this.quantityUpdateTimeout = setTimeout(async () => {
            await cartStore.UpdateProduct(this.cartItem.id, {
                quantity: newQuantity
            }, false);

            const matchingOrderLine = cartStore.FindOrderLine(this.cartItem.id)
            if(matchingOrderLine) {
                this.cartItem = matchingOrderLine;
                this.stagingQuantity = matchingOrderLine.quantity;
            }
        }, 300, []);
    }
    async removeItem() {
        let cartStore = getCartStore();
        await cartStore.RemoveProduct(this.cartItem.id, false);
    }
}